
import { Component, OnInit } from '@angular/core';
import { ScriptsModule } from '../../../modules/scripts.module';
import { ActivatedRoute, Router } from '@angular/router';
import { IntermService } from '../../../services/general/interm.service';
import { Intermediario }    from '../../../obj/intermediario'; 
declare var jquery:any;
declare var $ :any;
@Component({
  selector: 'app-cliente',
  templateUrl: './cliente.component.html',
  styleUrls: ['./cliente.component.css'],
  providers: [IntermService]
})
export class ClienteComponent implements OnInit {
  public modelUser;
  public modelInter;
  public model;
  constructor(private route: ActivatedRoute,private router: Router,private int:IntermService) {
  }
    
  ngOnInit(){
    let scripts = new ScriptsModule;
    // scripts.loadScript('assets/js/jquery.dataTables.js');
    // scripts.loadScript('assets/js/dataTables.bootstrap.min.js');
    scripts.loadScript('assets/js/slider_fss.js');
    scripts.loadScript('assets/js/jquery.mousewheel.min.js');
    scripts.loadScript('assets/js/scripts/intermediarios-plataforma.js'); 
    
    var usuario=  localStorage.getItem('currentUsuario');  
    //ACA SE DEBE CONTROLAR LOS EMAILS ENVIADOS
    if(usuario==null)          
       this.router.navigate(['/intermediarios']);       
    else{
       this.modelUser=JSON.parse(usuario); 
       this.modelInter= new Intermediario(); 
       
       this.model={codigo:"",identificacion:""};
       this.cargarClientes();      
    } 
  } 
    cargarClientes(){           
    
    this.model.idUsuario=this.modelUser.idIntermediario;

     this.int.getClientes(JSON.stringify(this.model)).then(resc => {
         this.modelInter.clientes=resc;
       });     
    }
    
    
}


// WEBPACK FOOTER //
// ./src/app/components/intermediarios/cliente/cliente.component.ts